import { Text } from "@meditect/medibase-components";

export const DeliveriesCannotCancelDeliveryWithValidatedBillStatementError = (): React.ReactElement => {
  return <Text>Cette réception est liée à un relevé de facture validé. L'abandon n'est pas autorisé.</Text>;
};
